import React from 'react';
import { IndustryType } from '../../types';
import { AISiteCreationFlow } from './AISiteCreationFlow';

interface SiteCreationWizardProps {
  isOpen: boolean;
  initialIndustry?: IndustryType;
  onClose: () => void;
  onSiteCreated: (siteId: string) => void;
  onOpenAiWizard?: (industry?: IndustryType) => void;
}

export const SiteCreationWizard: React.FC<SiteCreationWizardProps> = ({
  isOpen,
  initialIndustry,
  onClose,
  onSiteCreated,
}) => {
  return (
    <AISiteCreationFlow
      isOpen={isOpen}
      initialIndustry={initialIndustry}
      onClose={onClose}
      onSiteCreated={onSiteCreated}
    />
  );
};

export default SiteCreationWizard;
